<template>
  <div class="addTeachingPlan">
    <el-card class="box-card">
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="课程" prop="courseIds">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="addForm.courseIds"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请输入所属课程"
                :options="subjectTreeList"
                @change="subjectSearchChange"
              ></el-cascader>
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="8" :lg="12">
            <el-form-item label="计划名称" prop="name">
              <el-input v-model="addForm.name" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="课时明细">
            <div class="addTeachingPlan-detail">
              <div
                v-for="(item, index) in addForm.classCourseDetails"
                :key="index"
              >
                <div class="addTeachingPlan-form">
                  <el-form-item :label="'第' + (index + 1) + '课时'">
                    <!-- <span slot="label">第{{index+1}}课时</span> -->
                    <!-- <el-input style="width:200px" placeholder="" v-model="addForm.classCourseDetails[index].name"></el-input> -->
                    <i
                      v-if="!planBlock"
                      style="
                        float: right;
                        font-size: 16px;
                        margin-right: 20px;
                        margin-top: 12px;
                      "
                      class="el-icon-delete"
                      @click="delectSubjectKnowledge(index)"
                    ></i>
                  </el-form-item>
                </div>
                <el-form-item label="课时内容">
                  <el-cascader
                    style="width: 100%"
                    clearable
                    v-model="addForm.classCourseDetails[index].ids"
                    :show-all-levels="false"
                    :props="options"
                    collapse-tags
                    placeholder="请输入所属科目"
                    :options="ChapterTree"
                    @change="classCourseDetailChaptersChange(index)"
                  >
                    <!-- <template slot-scope="{ node, data }">
                        <span
                          style="display: inline-block; width: 100%"
                          @click="chapterKnowledgeList(node)"
                        >{{ data.name }}</span>
                      </template> -->
                  </el-cascader>
                </el-form-item>
              </div>
              <div class="addTeachingPlan-form" v-if="!planBlock">
                <el-button type="text" @click="addSubjectKnowledge()">
                  <i class="el-icon-plus addTeachingPlan-icon"></i>添加课时
                </el-button>
              </div>
            </div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item>
              <div>
                <el-button @click="goBack('addForm')">取消</el-button>
                <el-button type="primary" @click="submetData('addForm')"
                  >提交</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  data () {
    let _this = this;
    return {
      isShow: false,
      planBlock: true,
      courseName: "第一课时",
      courseIds: [],
      subjectTreeList: [],
      ChapterTree: [],
      searchForm: {},
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      options: {
        multiple: true,
        value: "id",
        label: "name",
        children: "children",
        // lazy: true,
        // leaf:'leaf',
        //   lazyLoad (node, resolve) {
        //     if(node.children.length>0){
        //       resolve(node.children);
        //     }else{
        //       _this.api.chapter.chapterKnowledgeList({chapterId: node.data.id}).then(result => {
        //         if(result.success){
        //           resolve(result.data);
        //         }
        //       });
        //     }
        //   }
      },
      formLabelWidth: "80px",
      input1: "",
      addForm: {
        classCourseDetails: [
          {
            ids: []
          }
        ],
        // obj: [
        //   {
        //     name: "",
        //     ids: []
        //   }
        // ]
      },
      addFormRules: {
        courseIds: [
          {
            required: true,
            message: "请选择课程",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入计划名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 30,
            message: "计划名称长度在1到30个字"
          }
        ]
      }
    };
  },
  methods: {
    handleItemChange () { },
    submetData (addForm) {
      if (this.$route.query.id) {
        this.updatePlan();
      } else {
        this.addPlan(addForm);
      }
    },
    addPlan (addForm) {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.plan.addPlan(this.addForm).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              // this.$router.push({ path: "/teachingPlan" });
              this.goBack(addForm)

            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    updatePlan () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.plan.updatePlan(this.addForm).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.$router.push({ path: "/teachingPlan" });
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    goBack (addForm) {
      this.$emit('handleClose2', this.isShow)
      this.$refs[addForm].resetFields()
      // this.addForm.classCourseDetails = []
    },
    addSubjectKnowledge () {
      let obj = { ids: [] };
      // this.addForm.obj.push(obj);
      // this.addForm.classCourseDetails.push(JSON.parse(JSON.stringify(obj)));
      this.addForm.classCourseDetails.push(obj);
    },
    delectSubjectKnowledge (index) {
      console.log(index);
      this.$confirm("此操作将永久删除该参数, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // this.addForm.obj.splice(index, 1);
        this.addForm.classCourseDetails.splice(index, 1);
      });
    },
    // 获取课程
    getSubjectTreeList () {
      this.api.getSubjectCourseTreeListByAgentId().then(result => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  delete itemss.children;
                }
              } else {
                // delete items.children;
              }
            }
          } else {
            // delete item.children;
          }
        }
        this.subjectTreeList = result.data;
        if (this.$route.query.id) {
          this.planBlock = true;
          this.getPlan();
        } else {
          this.planBlock = false;
        }
      })
        .catch(error => {
          console.log(error);
        });
    },
    getPlan () {
      this.api.plan.getPlan({ id: this.$route.query.id }).then(result => {
        if (result.success) {
          this.addForm = result.data;
          this.addForm.courseIds = this.addForm.subjectCourseId;
          this.getTree();
          // let k = JSON.parse(JSON.stringify(result.data.classCourseDetails));
          // this.$set(this.addForm, "obj", k);
          // this.addForm.courseIds = result.data.subjectCourseId;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    subjectSearchChange () {
      this.addForm.subjectCourseId = this.addForm.courseIds[2];
      this.getTree();
    },
    classCourseDetailChaptersChange (index) {
      // console.log("obj", this.addForm.obj);
      this.addForm.classCourseDetails[index].name = JSON.parse(JSON.stringify(this.addForm.obj[index].name));
      this.addForm.classCourseDetails[index].classCourseDetailChapters = JSON.parse(JSON.stringify(this.addForm.obj[index].classCourseDetailChapters));
      for (let i in this.addForm.classCourseDetails[index].classCourseDetailChapters) {
        this.addForm.classCourseDetails[index].classCourseDetailChapters[i] = { id: this.addForm.classCourseDetails[index].classCourseDetailChapters[i][1] };
      }
    },
    getTree () {
      this.api.chapter
        .getChapterAndKnowledgeSelectListByCourse({
          courseId: this.addForm.subjectCourseId
        })
        .then(result => {
          if (result.success) {
            for (let item of result.data) {
              if (item.children.length != 0) {
                for (let items of item.children) {
                  if (items.children.length != 0) {
                    for (let itemss of items.children) {
                      delete itemss.children;
                    }
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            this.ChapterTree = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    chapterKnowledgeList (node) {
      console.log("node", node)
      // if(node.data.chapterKnowledgeListhildren==null){
      //   this.api.chapter.chapterKnowledgeList({chapterId: node.data.id}).then(result => {
      //   });
      // }
    },
  },
  computed: {},
  mounted () {
    this.getSubjectTreeList();
  }
};
</script>
<style scoped>
.addTeachingPlan-detail {
  border: 1px solid rgba(238, 238, 238, 1);
  padding: 10px;
}
.addTeachingPlan-form {
  background-color: rgba(246, 249, 250, 1);
  height: 38px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.addTeachingPlan-icon {
  margin-left: 20px;
}
.el-card {
  border: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/classManage/addTeaching.vue